import { useEffect } from "react"
import { sessionExpirationEmitter } from "@/lib/session-expiration-emitter"

export function useSessionExpiration(onSessionExpired: () => void): void {
  useEffect(() => {
    const unsubscribe = sessionExpirationEmitter.onSessionExpired(
      onSessionExpired
    )
    return unsubscribe
  }, [onSessionExpired])
}
